// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-subSection__description":"jobSearchDetail-subSection__description"};